import Images from 'app/assets/img';
import { ReactComponent as CloseIcon } from 'app/assets/img/close_icon.svg';
import { ReactComponent as LocationIcon } from 'app/assets/img/icon_Location_Detail_Show.svg';
import ModalContainer from 'app/components/ModalContainer';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import TooltipParagraph from 'app/pages/Catalog/tooltipParagraph';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ReadMore from '../ReadMore';
interface IDialogAllTicketsProps {
  tickets: any[];
  isShow: boolean;
  onCloseDialog: () => void;
}
const FALLBACK_IMAGE = Images.ImgBanner;
const DialogAllTickets: React.FC<IDialogAllTicketsProps> = props => {
  const { tickets, isShow, onCloseDialog } = props;
  const translations = useSelector(selectTranslations);
  return (
    <ModalContainer
      isShow={isShow}
      onCloseDialog={onCloseDialog}
      maskClosable={true}
      modalPadding="0 24px 32px"
      modalHeight="initial"
      styleSlots={{
        iconWrapperStyle: {
          margin: '0 16px 0 0',
        },
        modalContentStyle: {
          maxWidth: 980,
          width: '96vw',
          maxHeight: '96vh',
        },
        modalBodyStyle: {
          height: 'fit-content',
        },
      }}
      modalProps={{ destroyOnClose: true }}
      CloseIcon={<></>}
    >
      <Header>
        <TitleModel>
          {translations?.['b2b.txt.sunWorldTicketInfo'] || ''}
        </TitleModel>
        <ButtonClose onClick={onCloseDialog}>
          <CloseIcon width={12} height={12} />
        </ButtonClose>
      </Header>
      {tickets?.map(item => {
        return (
          <ItemTicket key={item.id}>
            <TicketRow>
              <TicketWrapper>
                <TicketContent>
                  <ImageWrapper>
                    <TicketImage
                      src={item?.imageUrl || FALLBACK_IMAGE}
                      alt=""
                      onError={e => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = FALLBACK_IMAGE;
                      }}
                    />
                  </ImageWrapper>
                  <Content>
                    <TooltipParagraph
                      className="fw-bold mb-1"
                      style={{
                        maxWidth: '100%',
                      }}
                      ellipsis={{ rows: 2 }}
                    >
                      {item.name || ''}
                    </TooltipParagraph>
                    <Location>
                      <LocationIcon width={16} height={16} />
                      <span>{item.otaSiteName || ''}</span>
                    </Location>
                    <ReadMore lines={3} html={item.description} />
                  </Content>
                </TicketContent>
              </TicketWrapper>
            </TicketRow>
          </ItemTicket>
        );
      })}
    </ModalContainer>
  );
};
export default DialogAllTickets;
const ItemTicket = styled.div`
  margin: 12px 0;
  border-radius: 10px;
  background: #f2f2f2;
`;

const TicketRow = styled.div`
  display: flex;
  gap: 12px;
`;

const TicketWrapper = styled.div`
  flex: 1;
  background: #fff;
  border-radius: 10px;
  border: 2px solid #f2f2f2;
`;

const TicketContent = styled.div`
  display: flex;
  gap: 16px;
  padding: 16px;
`;

const ImageWrapper = styled.div`
  flex-shrink: 0;
`;

const TicketImage = styled.img`
  width: 96px;
  height: 96px;
  object-fit: cover;
  border-radius: 8px;
`;

const Content = styled.div`
  flex: 1;
  min-width: 0;
`;
const Header = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: -24px;
  margin-right: -24px;
  margin-top: -16px;
  z-index: 10;
  background: #fff;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 24px;
  border-radius: 16px 16px 0 0;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 30px;
`;
const TitleModel = styled.div`
  font-size: 16px;
  font-weight: 600;
`;
const ButtonClose = styled.div`
  font-size: 16px;
  font-weight: 600;
  &:hover {
    cursor: pointer;
  }
  margin-right: 24px;
`;

const Location = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  margin-bottom: 6px;
`;
